"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCitiesLayer = exports.getCountiesLayer = exports.getParcelCountWithRingsAndURL = void 0;
const axios_1 = __importDefault(require("axios"));
const qs = __importStar(require("qs"));
// Returns how many CA parcels are within a given geometry.
const getParcelCountWithRingsAndURL = async (geometry, url) => {
    if (!geometry.type || !geometry.coordinates) {
        return null;
    }
    if (geometry.type === "MultiPolygon") {
        let sum = 0;
        for (let i = 0; i < geometry.coordinates.length; i++) {
            const count = await (0, exports.getParcelCountWithRingsAndURL)({ type: "Polygon", coordinates: geometry.coordinates[i] }, url);
            if (count) {
                sum += count;
            }
        }
        return sum;
    }
    else if (geometry.type === "Polygon") {
        try {
            const data = {
                f: "geojson",
                where: "1=1",
                geometry: JSON.stringify({ rings: geometry.coordinates, wkid: 4362 }),
                geometryType: "esriGeometryPolygon",
                spatialRel: "esriSpatialRelIntersects",
                returnGeometry: "true",
                returnCountOnly: "true",
                inSR: "4326",
            };
            const options = {
                method: "POST",
                headers: { "content-type": "application/x-www-form-urlencoded" },
                data: qs.stringify(data),
                url,
            };
            // @ts-ignore
            return (0, axios_1.default)(options)
                .then(function (response) {
                var _a, _b;
                return (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : null;
            })
                .catch(function (error) {
                return null;
            });
        }
        catch (e) {
            return null;
        }
    }
    else {
        return null;
    }
};
exports.getParcelCountWithRingsAndURL = getParcelCountWithRingsAndURL;
const getCountiesLayer = async () => {
    return fetch("https://firebasestorage.googleapis.com/v0/b/natomas-staging.appspot.com/o/build%2Fgeojson%2Fcounties.geojson?alt=media&token=");
};
exports.getCountiesLayer = getCountiesLayer;
const getCitiesLayer = async () => {
    return fetch("https://firebasestorage.googleapis.com/v0/b/natomas-staging.appspot.com/o/build%2Fgeojson%2FcitiesMerged.geojson?alt=media&token=");
};
exports.getCitiesLayer = getCitiesLayer;
//# sourceMappingURL=boundaries.js.map